module.exports = __webpack_public_path__ + "img/6.c2151425.png";